<div class="feedback-popup right-side-popup">
    
    <div class="dialog-header">
        <h2 mat-dialog-title ></h2>
        <button mat-button mat-dialog-close><span
            class="material-icons">close</span>
        </button>
    </div>
    <form [formGroup]="applicationForm" >
    <div class="feedback-popup-contnent right-popup-content   ">
        <div class="box-labelsuper margin-top2">
            <h4 *ngIf="popupType=='feedback' ">Send Feedback</h4>
            <h4 *ngIf="popupType=='messagetoTeam' ">Send Message to your team</h4>
        </div>

        <mat-label class="labelsuper" *ngIf="popupType=='feedback' " >As we continue to improve our website, please let us know your thoughts.</mat-label>
        <mat-divider class="divider"></mat-divider>
        <div class="row" *ngIf="popupType=='messagetoTeam' " >
          <div class="col l12 m12 s12">
            <div class="field-group">
              <mat-label>Select Recipient</mat-label>
              <mat-form-field appearance="fill" class="selectfield" >
                <mat-select formControlName="selectedTeamMember" (selectionChange)="saveTeamMemberId($event)">
                    <mat-option *ngFor="let team of teamsId" value="{{team.value}}">{{team.name}}</mat-option>
                </mat-select>
            </mat-form-field>
                           </div>
                           <mat-chip-list class="mat-chip-list" aria-label="Color selection">
                            <mat-chip *ngFor="let chip of selectedData" selected >
                              {{chip.name}}
                              <button matChipRemove (click)="removeteamInUI(chip.value)">
                                <mat-icon>cancel</mat-icon>
                              </button>
                            </mat-chip>
  
                          </mat-chip-list>
          </div>
        </div>
  
     
     
     
        <div class="row">
            
            
            <div class="col l12 m12 s12">
                <!-- <mat-label class="labelsuper-normal">Write Some Feedback</mat-label> -->
                <mat-form-field appearance="outline" class="custom-form-field textarea100">
                  <textarea  
                    matInput
                    placeholder="Compose message"
                   rows="5"
                    formControlName="description"
                  ></textarea>
                </mat-form-field>
              </div>
        </div>

        
    </div>
    <!-- <mat-dialog-actions class="btn-col-footer btn-bottom">
        <button mat-button color="primary" mat-dialog-close>Cancel</button>
        <div class="attach-send-btn">
            <button mat-icon-button color="primary" ><mat-icon> attach_file</mat-icon></button>

            <button mat-button  class="green" (click)="onSubmit()"  >
                Send
              </button>
        </div>
      </mat-dialog-actions> -->

      <!-- <div class="right-popup-bottom">
        <button mat-button color="primary" class="cancel-btn" mat-dialog-close>Cancel</button>
        <div class="attach-send-btn">
          <button mat-icon-button class="attach-btn" ><mat-icon> attach_file</mat-icon></button>

          <button mat-button  class="send-btn" (click)="onSubmit()"  >
              Send
            </button>
      </div>
      </div> -->
</form>

<mat-dialog-actions class="btn-col-footer right-popup-bottom">
  <button mat-button  class="cancel-btn" mat-dialog-close>Cancel</button>
  <div class="attach-send-btn">
    <button mat-icon-button class="attach-btn" ><mat-icon> attach_file</mat-icon></button>
    <button mat-button  class="send-btn" (click)="onSubmit()"  >
        Send
      </button>
</div>
</mat-dialog-actions>
</div>